module.exports = __webpack_public_path__ + "img/C88467_5B3333_875C5A_7A3822-256px.1133c532.png";